export const show_loader = 'show_loader';
export const hide_loader = 'hide_loader';

export const ShowLoader = () => ({
    type: show_loader
})
export const HideLoader = () => ({
    type: hide_loader
})
